<template>
  <div>
    <protocol-header v-if="protocol"
                     :protocol="protocol"
                     :show-secondary="false"></protocol-header>
    
    <div class="row">
      <div class="col-12">
        <form id="frm-evaluation"
              ref="frm-evaluation"
              accept-charset="UTF-8"
              class="card"
              method="POST"
              :action="`/protocolo/${protocol.id}/${task.committee.key}/condicionado`"
              onsubmit="return false">
          <input type="hidden" name="_token" :value="token" />
          
          <div class="card-header">
            <h1 class="card-title mb-0">{{ task.classification.title }}</h1>
          </div>
          
          <div class="card-body">
            <div class="form-group" v-if="task.last_dictum">
              <label class="d-block font-weight-normal"
                     for="dictum_type">Dictamen:
              </label>
              <input type="text"
                     name="status"
                     id="dictum_type"
                     :value="task.last_dictum.type.title"
                     class="form-control"
                     disabled/>
            </div>
            
            <div class="form-group">
              <label class="d-block font-weight-normal"
                     for="evaluation_date">Fecha de dictamen:
              </label>
              <input type="text"
                     name="status"
                     id="evaluation_date"
                     :value="evaluationDate"
                     class="form-control"
                     disabled/>
            </div>
            
            <div class="form-group">
              <span class="d-inline-block font-weight-normal">Documento adjunto:</span>
              <span class="far fa-file-pdf text-danger"></span>
              <a :href="`/${task.last_dictum.file_path}`"
                 :title="task.last_dictum.file_name">{{ task.last_dictum.file_name }}</a>
            </div>
            
            <div class="form-group">
              <label class="d-block font-weight-normal"
                     for="comments">Comentarios:
                <abbr style="text-decoration: none;"
                      title="Campo obligatorio">*</abbr>
              </label>
              <textarea id="comments"
                        :value="task.last_dictum ? task.last_dictum.comments : ''"
                        class="form-control"
                        name="comments"
                        placeholder="Ingrese sus observaciones..."
                        rows="3"
                        disabled
                        ref="comments"></textarea>
            </div>
            
            <div class="form-group">
              <button type="button"
                      class="btn btn-primary btn-lg"
                      :disabled="sending"
                      @click="editProtocol">
                <spinner small class="text-white"
                         v-if="sending"></spinner>
                Editar protocolo
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
  import ProtocolHeader from './ProtocolHeader'
  import autosize from 'autosize'
  import moment from 'moment'
  import Spinner from '../ui/Spinner'
  
  export default {
    name: 'ProtocolConditioned',
    components: {
      Spinner,
      ProtocolHeader,
    },
    props: {
      user: Object,
      protocol: Object,
      task: Object,
    },
    data: () => ({
      sending: false,
    }),
    methods: {
      editProtocol () {
        this.sending = true
        
        this.$refs['frm-evaluation'].submit()
      },
    },
    computed: {
      evaluationDate () {
        return moment(this.task.last_dictum.created_at).format('DD/MM/YYYY')
      },
      token() {
        return $('meta[name="csrf-token"]').prop('content')
      },
    },
    mounted () {
      autosize(document.getElementById('comments'))
    },
  }
</script>
